import IconButton from '@/components/Buttons/IconButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { useFiltersReset } from '@/hooks/useFiltersReset';
import Refresh from '@/images/Refresh.svg';
import theme from '@/theme';
import styled from '@emotion/styled';

const TransparentIconButton = styled(IconButton)`
    margin-left: auto;
    border-radius: 50px !important;
    background-color: transparent;
    border: 1px solid ${theme.colors.black[200]};
    height: 34px;
    font-size: 14px;
    padding: 7px 14px;
    color: ${theme.colors.secondary[700]};
    align-items: center;

    &.MuiButtonBase-root:hover {
        background-color: #f3f3f3 !important;
    }

    &.MuiButtonBase-root:disabled {
        background-color: transparent !important;
    }

    svg {
        margin-right: 4px;
        color: ${theme.colors.secondary[900]};
    }
`;

export const ResetButton = () => {
    const { reset } = useFiltersReset();

    return (
        <TransparentIconButton data-testid="voice-filters-reset-btn" ariaLabel="reset-filters" onClick={reset}>
            <MaskedIcon src={Refresh} size="16px" />
            Reset
        </TransparentIconButton>
    );
};
